import React from 'react';

import { BooleanEditor } from '.';
//import { DateEditor    } from '.'
import { IntegerEditor } from '.';
import { FloatEditor } from '.';
//import { PercentEditor } from '.'
import { PlainEditor } from '.';

export var ValueEditor = function ValueEditor(props) {
  switch (props.field.dataType || 'text') {
    case 'boolean':
      return React.createElement(BooleanEditor, props);
    //case 'date'    : return <DateViewer    {...props} />
    case 'integer':
      return React.createElement(IntegerEditor, props);
    case 'percent':
    case 'float':
      return React.createElement(FloatEditor, props);
    //case 'percent' : return <PercentViewer {...props} />
    default:
      return React.createElement(PlainEditor, props);
  }
};